import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Tooltip,
  OverlayTrigger, Spinner,
  Modal
} from "react-bootstrap";
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { WithContext as ReactTags } from "react-tag-input";
import Select from "react-select";
import {Link} from 'react-router-dom'
import {
  coachAddSkill,
  coachDeleteSkill,
  getCategoryList,
} from "../../../utils/api";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";


const EditProfileSkills = (props) => {
  const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    const [programs, setprograms] = useState([]);
    const [tags, setTags] = useState([]);
    const [deletedTags, setdeletedTags] = useState([]);
    const [skill, setSkill] = useState([]);
    const [benefits, setbenefits] = useState({});
    const [professions, setprofessions] = useState({});
    const [tagList, settagList] = useState("");
    const [sessionType, setSessionType] = useState("Single");
    const [dataArray, setDataArray] = useState([]);
    const [deletedSessions, setdeletedSessions] = useState([]);
    const [session_name, setSession_name] = useState("");
    const [session_duration, setSession_duration] = useState("");
    const [sessionNameError, setSessionNameError] = useState(false);
    const [sessionDuration, setSessionDuration] = useState(false);
    const [visible, setVisible] = useState(false);
    const [progVisible, setProgVisible] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [selectedDuration, setSelectedDuration] = useState(null);
    const [isLoading, setisLoading] = useState(false);
    const [isSubmitting, setisSubmitting] = useState(false);
    const [hovered, setHovered] = useState(false);
  
  
    useEffect(() => {
      console.log("dddddddddd",user.programs)
      setprograms(user?.programs);
      setTags(
        user?.skills?.map((i) => ({
          id: i?.name,
          text: i?.name,
          skill_id: i?.id,
        })) || []
      );
      settagList(user?.tags?.toString());
  
      const transformedBenefit = user?.benefits?.reduce((acc, benefit, index) => {
        acc[index + 1] = benefit;
        return acc;
      }, {});
      setbenefits(transformedBenefit);
  
      const transformedProfession = user?.professions?.reduce(
        (acc, benefit, index) => {
          acc[index + 1] = benefit;
          return acc;
        },
        {}
      );
      setprofessions(transformedProfession);
    }, [user]);
  
    const getData = async () => {
      const skill = await getCategoryList();
      setSkill(
        skill?.data?.data?.map((i) => ({
          id: i?.name,
          text: i?.name,
          skill_id: i?.id,
        }))
      );
    };
  
    const KeyCodes = {
      comma: 188,
      enter: 13,
    };
  
    const delimiters = [KeyCodes.comma, KeyCodes.enter];
    const [inputValue, setInputValue] = useState('');
    
    const handleDelete = (i) => {
      setdeletedTags([...deletedTags, tags.find((_, index) => index === i)]);
      setTags(tags.filter((tag, index) => index !== i));
    };
  
    const renderSuggestion = (event) => {
      return <div>{event?.id || event?.text || event?.name}</div>;
    };
  
    const handleAddition = (tag) => {
      setInputValue("")
      const newTag = { ...tag, type: "new" };
      setTags([...tags, newTag]);
    };
  
    const handleDrag = (tag, currPos, newPos) => {
      const newTags = tags.slice();
  
      newTags.splice(currPos, 1);
      newTags.splice(newPos, 0, tag);
  
      // re-render
      setTags(newTags);
    };
  
    const handleTagClick = (index) => {
      console.log("The tag at index " + index + " was clicked");
    };
  
    const onClickSave = async (values) => {
      try {
        // handle program
        setisSubmitting(true);
       
        // handle skills
        if (tags?.length > 0) {
          const addSkill = new FormData();
          addSkill.append(
            "skill_ids",
            `[${tags?.filter((j) => j?.type !== "new")?.map((i) => i?.skill_id)}]`
          );
          await coachAddSkill(addSkill);
        }
        if(inputValue){
          const addSkill = new FormData();
            addSkill.append(
              "new_skills",
              `["${inputValue}"]`
            );
          await coachAddSkill(addSkill);
        }
        if (tags?.filter((i) => i?.type === "new")?.length > 0) {
          const addSkill = new FormData();
          addSkill.append(
            "new_skills",
            `[${tags
              ?.filter((j) => j?.type === "new")
              ?.map((i) => `"${i?.text}"`)}]`
          );
          await coachAddSkill(addSkill);
        }
  
        if (deletedTags?.length > 0) {
          const deleteSkill = new FormData();
          deleteSkill.append(
            "skill_ids",
            `[${deletedTags?.map((i) => i?.skill_id)}]`
          );
  
          await coachDeleteSkill(deleteSkill);
        }
  
        
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message);
        setisSubmitting(false);
      }
  
      getUserFromToken();
      setisSubmitting(false);
    };
  
  
    useEffect(() => {
      const canonicalUrl = window.location.origin + window.location.pathname;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
  
      getData();
    }, []);
  
   
    const onChangeTagList = (event) => {
      settagList(event?.target?.value);
    };
  
    const handleDeleteSection = (id, delete_type) => {
      if (delete_type === "programe") {
        setDeleteId(id);
        setProgVisible(true);
        setVisible(true);
      }
    };
  
    const tooltipSkill = (
      <Tooltip id="tooltip">
        <strong>Press enter </strong> after typing to create a new tag, or pick
        one from the list.
      </Tooltip>
    );
  

  return (
    <>
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
        {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Modal heading</Modal.Title>
        </Modal.Header> */}
        <Form>
          <Container>
            <Row className='g-3'>
              <Col lg="12">
                <div className="d-flex justify-content-start">
                  <Form.Label className="title me-2 fs-20">Skills</Form.Label>
                  <span className="fs-14">
                    <OverlayTrigger placement="top" overlay={tooltipSkill}>
                      <Image src={excl_i} />
                    </OverlayTrigger>
                  </span>
                </div>
                <div className="fs-14" style={{marginTop:'43px'}}>
                  <ReactTags
                    placeholder="Enter Your Skills"
                    tags={tags}
                    suggestions={skill}
                    delimiters={delimiters}
                    handleDelete={handleDelete}
                    handleAddition={handleAddition}
                    handleDrag={handleDrag}
                    handleTagClick={handleTagClick}
                    inputFieldPosition="top"
                    autocomplete
                    allowUnique={false}
                    renderSuggestion={renderSuggestion}
                    handleInputChange={(input) => setInputValue(input)} // Track input changes
                    classNames={{
                      tags: "tagsClass",
                      tagInput: "tagInputClass",
                      tagInputField: "tagInputFieldClass",
                      selected: "selectedClass",
                      tag: "tagClass",
                      remove: "removeClass",
                      suggestions: "suggestionsClass",
                      activeSuggestion: "activeSuggestionClass",
                      editTagInput: "editTagInputClass",
                      editTagInputField: "editTagInputField",
                      clearAll: "clearAllClass",
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' onClick={onClickSave}>Save</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </Modal>
    </>
  );
}

export default EditProfileSkills;